// extracted by mini-css-extract-plugin
export default {"amlResultDescription":"amlAlert_amlResultDescription__87-QL"};